import BaseAction from './BaseAction';

class OpenMailtoAction extends BaseAction {
    constructor(data) {
        super(data);
        this.hrefmailto = data.hrefmailto;
        this.target = data.target;
    }
}

export default OpenMailtoAction;